"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSample = exports.sampleShiped = exports.sampleReturnVerified = exports.sampleReturnShipped = exports.sampleReturnDelivered = exports.sampleReturnCompleted = exports.sampleDelivered = exports.sampleCancelled = exports.sampleArranged = exports.returnDeclineRejected = exports.returnDeclineAccepted = exports.getSamples = exports.getSampleStats = exports.getSampleById = exports.deleteSample = exports.defaultSampleData = exports.createSamples = exports.arrangeReturnPickup = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultSampleData = exports.defaultSampleData = {
  id: 0,
  enabled: false,
  leadId: 0,
  isLocal: false,
  deliveryBy: '',
  transporterId: 0,
  returnTransporterId: 0,
  deliveryAwbDetails: '',
  returnAwbDetails: '',
  currentStatus: '',
  isReturnGood: false,
  initiatedBy: 0,
  assignedTo: 0,
  sampleArrangedTimestamp: '',
  sampleCancelledTimestamp: '',
  sampleShipedTimestamp: '',
  sampleExpectedDeliveryTimestamp: '',
  sampleActualDeliveryTimestamp: '',
  sampleReturnDate: '',
  sampleExpectedReturnDeliveryTimestamp: '',
  sampleActualReturnDeliveryTimestamp: '',
  sampleReturnCompletedTimestamp: '',
  sampleCancelReason: '',
  comments: '',
  lead: undefined,
  initiatedUser: undefined,
  assignedUser: undefined,
  sampleLeadProduct: [],
  transporter: undefined,
  returnTransporter: undefined
};
const getSamples = params => (0, _request.default)({
  url: '/samples',
  method: 'get',
  params
});
exports.getSamples = getSamples;
const getSampleById = id => (0, _request.default)({
  url: `/samples/${id}`,
  method: 'get'
});
exports.getSampleById = getSampleById;
const updateSample = (id, data) => (0, _request.default)({
  url: `/samples/${id}`,
  method: 'patch',
  data
});
exports.updateSample = updateSample;
const deleteSample = id => (0, _request.default)({
  url: `/samples/${id}`,
  method: 'delete'
});
exports.deleteSample = deleteSample;
const createSamples = data => (0, _request.default)({
  url: '/samples/manage',
  method: 'post',
  data
});
exports.createSamples = createSamples;
const sampleArranged = data => (0, _request.default)({
  url: '/samples/sample-arranged',
  method: 'post',
  data
});
exports.sampleArranged = sampleArranged;
const sampleCancelled = data => (0, _request.default)({
  url: '/samples/sample-cancelled',
  method: 'post',
  data
});
exports.sampleCancelled = sampleCancelled;
const sampleShiped = data => (0, _request.default)({
  url: '/samples/sample-shiped',
  method: 'post',
  data
});
exports.sampleShiped = sampleShiped;
const sampleDelivered = data => (0, _request.default)({
  url: '/samples/sample-delivered',
  method: 'post',
  data
});
exports.sampleDelivered = sampleDelivered;
const arrangeReturnPickup = data => (0, _request.default)({
  url: '/samples/arrange-return-pickup',
  method: 'post',
  data
});
exports.arrangeReturnPickup = arrangeReturnPickup;
const sampleReturnShipped = data => (0, _request.default)({
  url: '/samples/return-shipped',
  method: 'post',
  data
});
exports.sampleReturnShipped = sampleReturnShipped;
const returnDeclineAccepted = data => (0, _request.default)({
  url: '/samples/return-decline-accepted',
  method: 'post',
  data
});
exports.returnDeclineAccepted = returnDeclineAccepted;
const returnDeclineRejected = data => (0, _request.default)({
  url: '/samples/return-decline-rejected',
  method: 'post',
  data
});
exports.returnDeclineRejected = returnDeclineRejected;
const sampleReturnDelivered = data => (0, _request.default)({
  url: '/samples/sample-return-delivered',
  method: 'post',
  data
});
exports.sampleReturnDelivered = sampleReturnDelivered;
const sampleReturnVerified = data => (0, _request.default)({
  url: '/samples/sample-return-verified',
  method: 'post',
  data
});
exports.sampleReturnVerified = sampleReturnVerified;
const sampleReturnCompleted = data => (0, _request.default)({
  url: '/samples/sample-return-completed',
  method: 'post',
  data
});
exports.sampleReturnCompleted = sampleReturnCompleted;
const getSampleStats = params => (0, _request.default)({
  url: 'samples/stats',
  method: 'get',
  params
});
exports.getSampleStats = getSampleStats;